import { StatusApi } from '@flippingbook/web.utils/dist/apis/status';
import type { IStatusApi } from '@flippingbook/web.utils/dist/apis/status';

import { httpClient } from '@/services/instance/api/httpClient';

export const statusApi: IStatusApi = new StatusApi({
    httpClient,
});
